<template>
  <e-chart :options="chartOptions" :autoresize="true" />
</template>

<script>
import moment from 'moment';

import colorPalette from '@/xvisor/constants/colorPalette';
import themeStyle from '@/xvisor/utilities/themeStyle';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ts() {
      return this.data.points ? this.data.points : [];
    },
    units() {
      return this.data.units ? this.data.units : '';
    },
    toggleColor() {
      return themeStyle.styleToggle(colorPalette.black, colorPalette.white);
    },
    chartOptions() {
      const values = this.ts.map((point) => [
        moment(point.time).valueOf(),
        point.value,
      ]);
      return {
        tooltip: { trigger: 'axis' },
        grid: {
          top: 60,
          left: 50,
          right: 30,
          bottom: 50,
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          splitLine: {
            show: false,
          },
          axisTick: {
            lineStyle: {
              color: this.toggleColor,
            },
          },
          axisLine: {
            lineStyle: {
              color: this.toggleColor,
            },
          },
          axisLabel: {
            formatter: (value) => moment(value).format('MMM D h:mm A'),
            fontSize: 9,
          },
        },
        yAxis: [
          {
            type: 'value',
            name: this.units,
            nameLocation: 'middle',
            nameRotate: 90,
            nameGap: 30,
            axisTick: {
              lineStyle: {
                color: this.toggleColor,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.toggleColor,
              },
            },
          },
        ],
        series: [
          {
            name: this.units,
            type: 'line',
            data: values,
            smooth: true,
            showSymbol: false,
            areaStyle: { opacity: 0.1 },
          },
        ],
      };
    },
  },
};
</script>
